module.exports = __webpack_public_path__ + "assets/img/13a.07fe7fb0.jpg";